import { render, staticRenderFns } from "./publish-evaluate.vue?vue&type=template&id=25fcbd88&scoped=true"
import script from "./publish-evaluate.vue?vue&type=script&lang=js"
export * from "./publish-evaluate.vue?vue&type=script&lang=js"
import style0 from "./publish-evaluate.vue?vue&type=style&index=0&id=25fcbd88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fcbd88",
  null
  
)

export default component.exports